$shm_hitalama_benchmarks_page $mol_book2
	menu_title \Бенчмарк
	version \-
	page_number? 0
	auto /
		^
		<= connection_auto null
		<= archive_auto null
		<= indexes_auto null
	pages /
		<= Settings $shm_hitalama_guide_page
			title \Бенчмарк
			help_section \benchmark
			minimal_width 352
			body /
				<= Computer_label $mol_labeler
					title \Параметры компьютера
					content /
						<= Computer $mol_textarea
							value? <=> computer? \
							hint \Процессор, RAM, ОС и другие параметры
							length_max 8000
				<= Count_label $mol_labeler
					title \Количество записей
					content /
						<= Count $mol_select
							value? <=> count? \500
							dictionary *
								1 \1
								10 \10 — проверка запуска
								100 \100
								500 \500
								1000 \1000
								2000 \2000
								4000 \4000
								8000 \8000
								all \1 / 100 / 500 / 1000 / 2000 / 4000 / 8000
				<= Fields_label $mol_labeler
					title \Свойства
					content /
						<= Fields $mol_select
							value? <=> fields? \4
							dictionary *
								4 \4
								10 \10
								all \4 и 10
				<= Storage_label $mol_labeler
					title \Хранение
					content /
						\Шарды по 256 записей
				<= Packing_label $mol_labeler
					title \Запись свойств
					content /
						<= Packing $mol_select
							value? <=> packing? \packed
							dictionary *
								granular \Отдельные CRDT-атомы
								packed \Initial + независимые изменения
								all \Оба варианта
				<= Start $mol_button_major
					title \Запустить
					enabled <= start_enabled true
					click? <=> start? null
				<= Stop $mol_button_minor
					title \Остановить
					enabled <= stop_enabled false
					click? <=> stop? null
				<= Status $mol_text
					text <= status_text \
				<= Duration $mol_text
					text <= duration_text \
				<= Error $mol_text
					text <= error_text \
		<= Results $mol_page
			title \Результаты прогонов
			minimal_width 640
			body /
				^ live_views / <= Live $shm_hitalama_benchmarks_client_frame
					client <= client $shm_hitalama_benchmarks_client
					title \Текущий шаг бенчмарка
					uri <= frame_uri \
					minimal_height 600
				^ pagination_views / <= Pagination_top $shm_paginator
					page? <=> page_number?
					total <= total_rows 0
				<= Metrics $shm_hitalama_benchmarks_page_metrics
					records <= metrics *
					row_delete*? <=> row_delete*? null
				<= Report_download $mol_button_download
					title \Скачать результаты JSON
					blob <= report_blob $mol_blob
					file_name \benchmark.json
